<template>
  <el-tag :type="type"
          class="app-state-alert"
          effect="dark"
          size="mini">
    {{ $t(`STATE_ALERT.${value}`) }}
  </el-tag>
</template>

<script>
export default {
  name: 'AppStateAlert',
  props: {
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    type () {
      switch (this.value) {
        case 'PENDING':
          return 'warning'
          break
        case 'CANCELED':
          return 'danger'
          break
        default:
          return 'success'
          break
      }
    }
  }
}
</script>
